import React, { Component } from 'react';
import { Card, Col, Row, Form, Button, Table, InputGroup, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import moment from "moment";
import ReactToPrint from "react-to-print";
import { reportService } from '../../Services/reportService';

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class Vendors extends Component {
    state = {
        reportObj: [],
        startDate: "",
        endDate: "",
        search: "",
        loader: false
    };

    componentDidMount() {
        this.componentRef = React.createRef();
        this.getVendorReport();
    }

    getVendorReport = (params = {}) => {
        this.setState({ loader: true });
        // const prm = { ...params, page : 1, limit : 10 }
        reportService.getVendorReport(params).then(result => {
            if (result.status === true) {
                const data = result.data.filter((itm)=> itm?.costs)
                this.setState({ reportObj: data });
            } else {
                toast.info("Something went wrong");
            }
            this.setState({ loader: false });
        });
    };

    exportToExcel = () => {
        let params = { startDate: this.state.startDate, endDate: this.state.endDate };
        reportService.exportVendors(params).then(result => {
            if (result.status === true) {
                window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
            } else {
                toast.error("Something went wrong");
            }
        });
    };

    handleInputChange = (e) => {
        this.setState({ search: e.target.value });
    };

    handleSearch = () => {
        const { search, startDate, endDate } = this.state;
        let params = { startDate, endDate };

        if (search) {
            params = { ...params, search };
        }
        this.getVendorReport(params);
    };

    handleDateChange = (e) => {
        const { name, value } = e.target;
        let setdate = name === "start_date" ? "startDate" : "endDate";

        const selectedDate = new Date(value).getTime();
        this.setState({ [setdate]: selectedDate }, () => {
            const { startDate, endDate } = this.state;

            if (startDate !== "" && endDate !== "") {
                if (startDate > endDate) {
                    this.setState({ startDate: "", endDate: "" });
                    toast.info("Start date cannot be greater than end date.");
                } else {
                    this.getVendorReport({ startDate, endDate });
                }
            }
        });
    };

    render() {
        const { reportObj, loader } = this.state;
        let revTotal = 0, costTotal = 0, profitTotal = 0;

        return (
            <Card>
                <div className="card-header bg-light"><h4>Vendors</h4></div>
                <Card.Body>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Label>Search</Form.Label>
                            <InputGroup>
                                <Form.Control
                                style={{padding : "5px"}}
                                    type="text"
                                    name="search"
                                    placeholder="Name"
                                    onChange={this.handleInputChange}
                                />
                                {/* <Button style={{backgroundColor : "rgb(229, 228, 236)"}} onClick={this.handleSearch}>
                                    Search
                                </Button> */}
                                <div className="input-group-prepend">
                    <button
                      className="input-group-text pointer search-btn"
                      onClick={this.handleSearch}
                      style={{ backgroundColor: "#e5e4ec", padding : "5px" }}
                    >
                      search
                    </button>
                  </div>
                            </InputGroup>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="start_date"
                                max={new Date().toISOString().split('T')[0]}
                                onChange={this.handleDateChange}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="end_date"
                                max={new Date().toISOString().split('T')[0]}
                                onChange={this.handleDateChange}
                            />
                        </Col>
                        <Col md={3} className="d-flex justify-content-end mt-3">
                            <Button className="me-1" variant="success" onClick={this.exportToExcel}> Excel </Button>
                            <ReactToPrint
                                trigger={() => <Button variant="secondary">Print</Button>}
                                content={() => this.componentRef}
                                bodyClass="printElement"
                            />
                        </Col>
                    </Row>

                    <Row className='printElement' ref={el => (this.componentRef = el)}>
                    <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Vendor Name</th>
                                    <th>Invoice Number</th>
                                    <th>Service</th>
                                    <th>Job Number</th>
                                    <th>Date</th>
                                    <th>Revenue</th>
                                    <th>Cost</th>
                                    <th>Profit</th>
                                    <th>Profit(%)</th>
                                </tr>
                            </thead>
                            {loader ? (
                                <tbody>
                                    <tr>
                                        <td colSpan={9} className='text-center'>
                                            <Spinner animation="border" />
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <tbody>
                                    {reportObj.length ? reportObj.map((item, index) => {
                                            let rev = item.invoices?.item.find(type => type.item_name === item.costs.cost_item_name)?.lc_amount || 0;
                                            let cost = item.costs.lc_amount;
                                            let profit = rev - cost;
                                            let profitPer = profit !== 0 && cost !== 0 ? (profit / cost) * 100 : 0;
                                            revTotal += rev;
                                            costTotal += cost;
                                            profitTotal += profit;

                                            const vendorName = (item?.costs?.qbook_vendor_name && item.costs.qbook_vendor_name.length>20)
                                                                ? item.costs.qbook_vendor_name.slice(0,20) : item.costs.qbook_vendor_name

                                            return (
                                                <tr key={index} className={item?.costs?.draft ? "custom-tr-drft" : "custom-tr-book"}>
                                                <td>{index + 1}</td>
                                                   
                                                    <td className="str-hover-show" showfullonhover={item?.costs?.qbook_vendor_name}>{vendorName}</td>
                                                    <td>{item.costs.invoice_number || "-"}</td>
                                                    <td>{item.costs.cost_item_name}</td>
                                                    <td>{item.job_token}</td>
                                                    <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                                                    <td>{rev.toFixed(2)}</td>
                                                    <td>{cost.toFixed(2)}</td>
                                                    <td>{profit.toFixed(2)}</td>
                                                    <td>{profitPer.toFixed(2)}</td>
                                                </tr>
                                            );
                                    }) : <tr><td colSpan={9} className='text-center'>Data Not Found</td></tr>}
                                    <tr>
                                        <td colSpan={6}>Total</td>
                                        <td>{revTotal.toFixed(2)}</td>
                                        <td>{costTotal.toFixed(2)}</td>
                                        <td>{profitTotal.toFixed(2)}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                        </div>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export { Vendors };

